export const SDK_VERSION = '7.31.0';
